import { MessageCircle, PenLine, LineChart, Handshake, Sparkles, Plus } from "lucide-react";
import { Reveal } from "./Reveal";

const TEAM = [
  { icon: MessageCircle, name: "Concierge", role: "Front door", body: "Interprets your voice or text intent, dispatches work to the right specialist, and hands answers back in plain English." },
  { icon: PenLine, name: "Copywriter", role: "Words department", body: "MLS remarks, hero paragraphs, Meta/Google ad copy, and social captions — all matched to your persona library." },
  { icon: LineChart, name: "Market Analyst", role: "Numbers desk", body: "Pulls comps, medians, days-on-market, and neighborhood narratives via RentCast + Apify. Prices with confidence." },
  { icon: Handshake, name: "Negotiator", role: "Deals room", body: "Reads inbound offers, drafts counters in your tone, flags red-flag terms, and coaches you through the call." },
  { icon: Sparkles, name: "Lead Qualifier", role: "Filter", body: "Scores every inbound lead 0–10. Extracts timeline, budget, and objections from the first message so you know before you call." },
  { icon: Plus, name: "Custom agents", role: "Bring your own", body: "Build a niche specialist in minutes — a Just-Listed poster, a farm-area drip-writer, a compliance reviewer — with your own prompt and tools." },
];

export const VirtualTeam = () => (
  <section id="team" className="py-24 md:py-32 border-t border-ink/10" data-testid="virtual-team-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl mb-14 md:mb-20">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">Your virtual back office</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink">
            Meet the <span className="italic text-coral">team</span> that never sleeps.
          </h2>
          <p className="mt-6 text-base md:text-lg text-ink/70">
            Five named specialists behind the one chat &mdash; plus room to build your own.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
        {TEAM.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.08}>
            <div className="bg-bone p-7 md:p-9 h-full" data-testid={`team-${t.name.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 border border-ink/15 flex items-center justify-center">
                  <t.icon className="w-5 h-5 text-coral" />
                </div>
                <span className="text-[10px] uppercase tracking-[0.2em] text-ink/50">{t.role}</span>
              </div>
              <h3 className="font-serif text-3xl text-ink">{t.name}</h3>
              <p className="mt-3 text-sm text-ink/65 leading-relaxed">{t.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
